var exports = {
  "nf": "x31de4314--0924cf--link",
  "e$": "x31de4314--0924cf--link-title",
  "zW": "x31de4314--0924cf--link-count",
};

module.exports = exports;
